import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-faq-page",
    templateUrl: "./faq-page.component.html",
    styleUrls: ["./faq-page.component.scss"],
})
export class FaqPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    pageTitleArea: pageTitle[] = [
        {
            title: "Frequently Asked Questions",
        },
    ];
    faqAccordion: Accordion[] = [
        {
            questions:
                "Q1. What does our Upstream Conceptual Data Model (UCDM) look like?",
            answer: `There are a few ways to view the Upstream Conceptual Data Model (UCDM). Report <strong>snapshots</strong> are generated in HTML and Excel format. You can view these snapshorts by going to one of the locations listed below
                <ol><li><a href="">Goto/udam</a> - HTML report</li>
               <li>Data Architecture and Operations</li>
                <li>You can also access the UCDM (not a snapshot) by going to ER/Studio's Team server <a href="">(https://goto/datamodel)</a></li></ol>

                <p>Note : If you do not have access to ER/Studio Team Server, submit a Generic Service Request to Assignment Group: DMTools requesting access to Team Server.</p>
            `,
        },
        {
            questions:
                "Q2. Whast does the Open Subsurface Data Universe (OSDU) data model look like?",
            answer: "At the time of posting this, the OSDU community has not developed a way to view the OSDU physical data model. Check with Bryan Dawson/Ryan Balazs about a 400 page construct. You can see a high level OSDU data model (showing Master Data and Work Product Componets) at the following <a href=''>link.</a>",
        },
        {
            questions:
                "Q3. What are the differences between the UCDM and the OSDU so we can know where we may need to influence OSDU?",
            answer: "<p>Each UCDM entity has metadata attached to it. This metedata can be seen in the reports/models(e.g. industryDataEnity).</p> <p>OSDU relese information will be downloaded to review Master and/or Works Product Component objects. The Data Steward Leads will identify which OSDU objects need to be either a) added as a new entity to the UCDM or b) need to be added as metadata to an existing UCDM. We don't expect all OSDU objects to be added to UCDM since OSDU is physical data model and not a conceptual data model. </p> <p>Regardless if the data steward leads want to use the OSDU object as the UCDM entity name, we do want to have the OSDU object identified within the metadata (e.g. industryDataEntity).</p>",
        },
        {
            questions:
                "Q4. How do we maintain the difference between OSDU and UCDM?",
            answer: "We are working with an MSP team to produce a UCDM dashboard. This is to help provide (we hope) a better view of the UCDM as well as eventually show Data Quality indictors. Because OSDU is a physical data model and the UCDM is a conceptual data model, it won't be a 1:1. Not every OSDU object will be in the UCDM as an entity or attached as metadata to an entity. The important/high value UCDM entities should be reflected in the OSDU model as objects.",
        },
        {
            questions: "Q5. Does the UCDM include a glossary of definitions?",
            answer: "The entity and entity definitions in the UCDM are provided by the Data Domain Steward or their nominated business data steward. These entities are then imported into Collibra. Eventually, ER/Studio will be able to send the entity names and entity definitions to Collibra via API.",
        },
    ];
}
class pageTitle {
    title: string;
}
class Accordion {
    questions: string;
    answer: string;
}
